<template>
  <div
    :class="[$style.base, { [$style.hasQuery]: !!calendarSearchQuery, [$style.searchVisible]: isSearchVisible, [$style.smallScreen]: $screen === 's' }]"
  >
    <div :class="$style.inner">
      <BaseIcon
        v-if="!isSearchVisible"
        name="search"
        :tooltip="$t('calendar.search_tooltip')"
        @click="isSearchVisible = true"
        v-intercom="'calendar-search'"
        v-highlight="'calendar-search'"
        v-test="'calendar-search-icon'"
      />
      <div
        v-else
        :class="$style.searchWrap"
      >
        <BaseSearch
          v-model="calendarSearchQuery"
          :debounce="350"
          forceCloseButton
          focus
          :placeholder="$t('calendar.search_tooltip')"
          @clear="isSearchVisible = false"
          v-test="'calendar-search-input'"
        />
        <BaseLabel
          v-show="!!calendarSearchQuery"
          v-test="'calendar-search-count'"
        >
          {{ calendarSearchResultIds.size }}
        </BaseLabel>
      </div>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useRoute } from 'vue-router';

import {
  calendarSearchQuery,
  calendarSearchResultIds,
} from './calendar-search';

const isSearchVisible = ref(false);

const route = useRoute();
const routeName = computed(() => (route?.name ? String(route?.name) : ''));

watch(routeName, () => {
  isSearchVisible.value = false;
});

watch(isSearchVisible, (newIsSearchVisible) => {
  if (newIsSearchVisible) {
    window.addEventListener('keydown', onKeyPress);
  } else {
    calendarSearchQuery.value = '';
    window.removeEventListener('keydown', onKeyPress);
  }
});

const onKeyPress = (e) => {
  if (e.key === 'Escape') {
    isSearchVisible.value = false;
    e.preventDefault();
  }
};

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeyPress);
});

onUnmounted(() => {
  calendarSearchQuery.value = '';
});
</script>

<style
  lang="scss"
  module
>
.base {
  &.searchVisible.smallScreen {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: $spacing;
    background-color: var(--color-bg);
  }
}

.inner {
  display: flex;
  align-items: center;
  height: $input-height;
}

.searchWrap {
  display: flex;
  align-items: center;
  gap: $spacing * .5;

  .base:not(.hasQuery) & {
    padding-right: 42px; // Padding with hardcoded value to preserve space for the count label and prevent the component from jumping to a new line. This value takes account for a label with a maximum value length of 3 characters.
  }
}
</style>
